export default __webpack_public_path__ + "static/media/or-4.018e8309.jpg";